/**
 * @file form - DynamicFormItem
 * @author sunwen05
 */

import _ from 'lodash';
import React from 'react';
import {Form, Button, Tooltip} from 'acud';
import {OutlinedMinusCircle, OutlinedPlus, OutlinedQuestionCircle} from 'acud-icon';

import DuFormItem from './DuFormItem';
import {CLS_PREFIX} from '../index';

import {DuFormItemProps} from '../../../../hooks/biz/form/interface';

export default (props: DuFormItemProps) => {
    // props数据
    const {prefixCls = CLS_PREFIX, control, option, formData} = props;
    const {formItemLabelLayout} = option.layouts;
    const {min = 1, max, rules = []} = _.get(control, 'dynamic', {});

    const dynamicItemCls = `${prefixCls}-item-dynamic`;

    const {infoIcon} = control;
    let {extra} = control;
    if (infoIcon) {
        const {className, tooltipProps} = infoIcon;
        extra = (
            <>
                <span className={`${className ? className : 'acud-form-extra-inline'}`}>
                    <Tooltip
                        {...tooltipProps}
                    >
                        <OutlinedQuestionCircle width={16} />
                    </Tooltip>
                </span>
                {extra}
            </>
        );
    }

    return (
        <Form.Item label={control.label}>
            <Form.List name={control.name} rules={rules}>
                {(fields, {add, remove}, {errors}) => {
                    if (fields.length < min) {
                        add();
                    }
                    return (
                        <div className={dynamicItemCls}>
                            {_.map(fields, field => (
                                <Form.Item
                                    {...formItemLabelLayout}
                                    key={field.key}
                                >
                                    <div className={`${dynamicItemCls}-item`}>
                                        <DuFormItem
                                            prefixCls={prefixCls}
                                            field={field}
                                            control={{...control, label: null, extra: null}}
                                            noLabel
                                            option={option}
                                            formData={formData}
                                        />
                                        {(fields.length > min) && (
                                            <OutlinedMinusCircle
                                                className="dynamic-delete-button"
                                                onClick={() => remove(field.name)}
                                            />
                                        )}
                                    </div>
                                </Form.Item>
                            ))}
                            <Form.Item
                                {...formItemLabelLayout}
                                extra={control.extra}
                            >
                                {!(max && fields.length >= max) && (
                                    <Button
                                        type="enhance"
                                        onClick={() => add()}
                                    >
                                        <OutlinedPlus />
                                    </Button>
                                )}
                                <Form.ErrorList errors={errors} />
                            </Form.Item>
                        </div>
                    );
                }}
            </Form.List>
        </Form.Item>
    );
};
